import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { API_V1_URL } from '../../../core/config/api.config';

export interface ForgotPasswordRequest {
    email: string;
    resetBaseUrl: string;
}

export interface ForgotPasswordResponse {
    message: string;
}

export interface ResetPasswordRequest {
    email: string;
    token: string;
    newPassword: string;
}

@Injectable({
    providedIn: 'root',
})
export class PasswordResetService {
    private readonly http = inject(HttpClient);

    forgotPassword(email: string): Observable<ForgotPasswordResponse> {
        return this.http.post<ForgotPasswordResponse>(`${API_V1_URL}/auth/forgot-password`, {
            email,
            resetBaseUrl: `${window.location.origin}/reset-password`,
        } satisfies ForgotPasswordRequest);
    }

    resetPassword(payload: ResetPasswordRequest): Observable<void> {
        return this.http.post<void>(`${API_V1_URL}/auth/reset-password`, payload);
    }
}